import React, { PureComponent, PropTypes } from 'react';
import NativeSelect from './NativeSelect';
import _ from 'underscore';
import { lpad } from 'underscore.string';

const leftPadTime = str => lpad(str, 2, '0');

const MINUTES_IN_DAY = 60 * 24;

const TIME_PATTERN = /\d{2}:\d{2}/;

const parseStrToMinutes = _.memoize(
  str => {
    if (typeof str === 'string' && TIME_PATTERN.test(str)) {
      const pcs = str.split(':');
      const hour = +pcs[ 0 ];
      const minute = +pcs[ 1 ];

      if (hour < 0 || hour > 23) {
        return null;
      }
      if (minute < 0 || minute > 59) {
        return null;
      }
      return hour * 60 + minute;
    }
    return null;
  }
);

const toMinuteOption = _.memoize(
  minutes => {
    const hour = Math.floor(minutes / 60);
    const minute = minutes % 60;
    const meridian = hour < 12 ? 'AM' : 'PM';
    const hourName = hour % 12 === 0 ? 12 : (hour % 12);

    return {
      id: `${leftPadTime(hour)}:${leftPadTime(minute)}`,
      group: `${hourName} ${meridian}`,
      name: `${hourName}:${leftPadTime(minute)} ${meridian}`
    };
  }
);

/**
 * Given a minute interval, return a set of options that are spaced by the interval
 */
const getMinuteOptions = _.memoize(
  minuteInterval => {
    return _.chain(_.range(0, MINUTES_IN_DAY, minuteInterval))
      .map(toMinuteOption)
      .value();
  }
);

const extractGroup = ({ group }) => group;

export default class NativeTimeSelect extends PureComponent {
  static propTypes = {
    minuteInterval: PropTypes.number
  };

  static defaultProps = {
    minuteInterval: 5,
    getGroup: extractGroup
  };

  handleChange = time => {
    const { onChange } = this.props;

    if (!time) {
      onChange(null);
    } else {
      onChange(time.id);
    }
  };

  render() {
    const { minuteInterval, value, ...rest } = this.props;

    const timeOptions = getMinuteOptions(minuteInterval);
    const timeValue = parseStrToMinutes(value);
    const selectedTime = timeValue && toMinuteOption(timeValue);

    return (
      <NativeSelect {...rest} options={timeOptions} value={selectedTime} onChange={this.handleChange}/>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/components/inputs/NativeTimeSelect.jsx